import { useEffect, useState } from "react";
import api from "../lib/api";
import { AlertTriangle } from "lucide-react";

export default function ConflictHint({ technicianId, start, jobId }) {
  const [c, setC] = useState([]);
  useEffect(() => {
    if (!technicianId || !start) { setC([]); return; }
    const t = setTimeout(() => api.get("/growth/conflicts", { params: { technician_id: technicianId, start, exclude_job: jobId || "" } }).then((r) => setC(r.data.conflicts)).catch(() => setC([])), 400);
    return () => clearTimeout(t);
  }, [technicianId, start, jobId]);
  if (!c.length) return null;
  return <div className="text-xs bg-amber-50 border border-amber-200 text-amber-800 rounded p-2 flex gap-2" data-testid="conflict-hint"><AlertTriangle className="h-4 w-4 shrink-0" /><div>Bu ustanın aynı saatte başka kaydı var: {c.map((x) => `${x.label} (${(x.at || "").slice(11, 16)})`).join(", ")}</div></div>;
}
